function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import * as R from 'ramda';
import { T4_BREAKPOINTS } from '../theme';
var getReducedContent = function getReducedContent(_ref) {
  var isWidthLess = _ref.isWidthLess,
    rest = _objectWithoutProperties(_ref, ['isWidthLess']);
  return R.pipe(R.evolve({
    title: R.of,
    subtitle: R.identity,
    uprs: R.of,
    disclaimer: function disclaimer(label) {
      return [{
        label: label
      }];
    }
  }), R.props(['title', 'subtitle', 'uprs', 'disclaimer']), R.cond([[R.always(isWidthLess(T4_BREAKPOINTS.xs2)), R.identity], [R.always(isWidthLess(T4_BREAKPOINTS.xs3)), R.tail], [R.T, R.always([])]]), R.unnest, R.reject(R.isNil))(rest);
};
export { getReducedContent };